import { render, staticRenderFns } from "./custom-company-objective.vue?vue&type=template&id=40be3302&scoped=true&"
import script from "./custom-company-objective.vue?vue&type=script&lang=js&"
export * from "./custom-company-objective.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-objective.vue?vue&type=style&index=0&id=40be3302&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40be3302",
  null
  
)

export default component.exports